import produce from 'immer';

// TYPES
import { Types, AtualizarPerfis } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: AtualizarPerfis = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): AtualizarPerfis {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_PERFIL: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_PERFIL_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_PERFIL_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_PERFIL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
